'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CandyMachinesV2Client = require('./CandyMachinesV2Client.cjs');
var createCandyMachineV2 = require('./operations/createCandyMachineV2.cjs');
var deleteCandyMachineV2 = require('./operations/deleteCandyMachineV2.cjs');
var findCandyMachineV2ByAddress = require('./operations/findCandyMachineV2ByAddress.cjs');
var findCandyMachinesV2ByPublicKeyField = require('./operations/findCandyMachinesV2ByPublicKeyField.cjs');
var findMintedNftsByCandyMachineV2 = require('./operations/findMintedNftsByCandyMachineV2.cjs');
var insertItemsToCandyMachineV2 = require('./operations/insertItemsToCandyMachineV2.cjs');
var mintCandyMachineV2 = require('./operations/mintCandyMachineV2.cjs');
var updateCandyMachineV2 = require('./operations/updateCandyMachineV2.cjs');

/** @group Plugins */
const candyMachineV2Module = () => ({
  install(metaplex) {
    const op = metaplex.operations();
    op.register(createCandyMachineV2.createCandyMachineV2Operation, createCandyMachineV2.createCandyMachineV2OperationHandler);
    op.register(deleteCandyMachineV2.deleteCandyMachineV2Operation, deleteCandyMachineV2.deleteCandyMachineV2OperationHandler);
    op.register(findCandyMachineV2ByAddress.findCandyMachineV2ByAddressOperation, findCandyMachineV2ByAddress.findCandyMachineV2ByAddressOperationHandler);
    op.register(findCandyMachinesV2ByPublicKeyField.findCandyMachinesV2ByPublicKeyFieldOperation, findCandyMachinesV2ByPublicKeyField.findCandyMachinesV2ByPublicKeyFieldOperationHandler);
    op.register(findMintedNftsByCandyMachineV2.findMintedNftsByCandyMachineV2Operation, findMintedNftsByCandyMachineV2.findMintedNftsByCandyMachineV2OperationHandler);
    op.register(insertItemsToCandyMachineV2.insertItemsToCandyMachineV2Operation, insertItemsToCandyMachineV2.InsertItemsToCandyMachineV2OperationHandler);
    op.register(mintCandyMachineV2.mintCandyMachineV2Operation, mintCandyMachineV2.mintCandyMachineV2OperationHandler);
    op.register(updateCandyMachineV2.updateCandyMachineV2Operation, updateCandyMachineV2.updateCandyMachineV2OperationHandler);
    metaplex.candyMachinesV2 = function () {
      return new CandyMachinesV2Client.CandyMachinesV2Client(this);
    };
  }
});

exports.candyMachineV2Module = candyMachineV2Module;
//# sourceMappingURL=plugin.cjs.map
